// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import {
//   Container, Typography, Box, TextField, Button, MenuItem, Select, InputLabel, FormControl, CircularProgress, Snackbar, Card, CardContent,
// } from '@mui/material';
// import { motion } from 'framer-motion';
// import axios from 'axios';

// const FeeStructure = () => {
//   const { state } = useLocation();
//   const { schoolId } = state || {};

//   const [year, setYear] = useState(new Date().getFullYear().toString());
//   const [className, setClassName] = useState('');
//   const [term, setTerm] = useState('Term 1');
//   const [amount, setAmount] = useState('');
//   const [feeStructures, setFeeStructures] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const classes = [
//     'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6',
//     'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12'
//   ];

//   useEffect(() => {
//     if (schoolId) fetchFeeStructures();
//   }, [schoolId]);

//   const fetchFeeStructures = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`https://kidsm.vercel.app/api/schools/${schoolId}/fee-structures`);
//       setFeeStructures(response.data);
//     } catch (error) {
//       console.error('Error fetching fee structures:', error);
//       setSnackbar({ open: true, message: 'Failed to fetch fee structures', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async () => {
//     if (!year || !className || !term || !amount) {
//       setSnackbar({ open: true, message: 'Please fill all fields', severity: 'error' });
//       return;
//     }

//     if (isNaN(amount)) {
//       setSnackbar({ open: true, message: 'Amount must be a number', severity: 'error' });
//       return;
//     }

//     try {
//       const response = await axios.post('https://kidsm.vercel.app/api/schools/update-fee-structure', {
//         schoolId,
//         year,
//         className,
//         term,
//         amount: parseFloat(amount),
//       });

//       setSnackbar({ open: true, message: response.data.message, severity: 'success' });
//       fetchFeeStructures();
//       setAmount('');
//     } catch (error) {
//       console.error('Error updating fee structure:', error);
//       setSnackbar({ open: true, message: 'Failed to update fee structure', severity: 'error' });
//     }
//   };

//   if (!schoolId) {
//     return (
//       <Container maxWidth="md" sx={{ py: 4, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
//         <Typography variant="h6" sx={{ textAlign: 'center', color: '#333' }}>
//           Error: No school ID provided
//         </Typography>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="md" sx={{ py: 4, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
//       <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
//         <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333', mb: 4, textAlign: 'center' }}>
//           Update Fee Structure
//         </Typography>

//         <Box sx={{ mb: 3 }}>
//           <TextField
//             fullWidth
//             label="Year"
//             value={year}
//             onChange={(e) => setYear(e.target.value)}
//             placeholder="e.g. 2023"
//             type="number"
//             sx={{ bgcolor: '#fff', borderRadius: 2 }}
//             variant="outlined"
//           />
//         </Box>

//         <Box sx={{ mb: 3 }}>
//           <FormControl fullWidth>
//             <InputLabel id="class-label">Class</InputLabel>
//             <Select
//               labelId="class-label"
//               value={className}
//               label="Class"
//               onChange={(e) => setClassName(e.target.value)}
//               sx={{ bgcolor: '#fff', borderRadius: 2 }}
//             >
//               <MenuItem value="">Select Class</MenuItem>
//               {classes.map((cls) => (
//                 <MenuItem key={cls} value={cls}>{cls}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Box>

//         <Box sx={{ mb: 3 }}>
//           <FormControl fullWidth>
//             <InputLabel id="term-label">Term</InputLabel>
//             <Select
//               labelId="term-label"
//               value={term}
//               label="Term"
//               onChange={(e) => setTerm(e.target.value)}
//               sx={{ bgcolor: '#fff', borderRadius: 2 }}
//             >
//               <MenuItem value="Term 1">Term 1</MenuItem>
//               <MenuItem value="Term 2">Term 2</MenuItem>
//               <MenuItem value="Term 3">Term 3</MenuItem>
//             </Select>
//           </FormControl>
//         </Box>

//         <Box sx={{ mb: 3 }}>
//           <TextField
//             fullWidth
//             label="Amount (KES)"
//             value={amount}
//             onChange={(e) => setAmount(e.target.value)}
//             placeholder="Enter amount"
//             type="number"
//             sx={{ bgcolor: '#fff', borderRadius: 2 }}
//             variant="outlined"
//           />
//         </Box>

//         <Button
//           fullWidth
//           variant="contained"
//           onClick={handleSubmit}
//           sx={{
//             bgcolor: '#6200ee',
//             borderRadius: 2,
//             py: 1.5,
//             textTransform: 'none',
//             fontWeight: 'bold',
//             '&:hover': { bgcolor: '#3700b3' },
//           }}
//         >
//           Submit
//         </Button>

//         <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333', mt: 4, mb: 2 }}>
//           Current Fee Structures
//         </Typography>

//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
//             <CircularProgress color="primary" />
//           </Box>
//         ) : feeStructures.length === 0 ? (
//           <Typography sx={{ fontSize: '1rem', color: '#666', textAlign: 'center' }}>
//             No fee structures found
//           </Typography>
//         ) : (
//           feeStructures.map((fee) => (
//             <Card key={fee._id} sx={{ bgcolor: '#fff', borderRadius: 2, mb: 2, borderLeft: '4px solid #6200ee' }}>
//               <CardContent>
//                 <Typography sx={{ fontSize: '0.875rem', color: '#666', mb: 0.5 }}>Year: {fee.year}</Typography>
//                 <Typography sx={{ fontSize: '0.875rem', color: '#666', mb: 0.5 }}>Class: {fee.className}</Typography>
//                 <Typography sx={{ fontSize: '0.875rem', color: '#666', mb: 0.5 }}>Term: {fee.term}</Typography>
//                 <Typography sx={{ fontSize: '0.875rem', color: '#666' }}>Amount: KES {fee.amount.toLocaleString()}</Typography>
//               </CardContent>
//             </Card>
//           ))
//         )}
//       </motion.div>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         message={snackbar.message}
//         sx={{ bgcolor: snackbar.severity === 'success' ? '#4CAF50' : '#e74c3c' }}
//       />
//     </Container>
//   );
// };

// export default FeeStructure;



import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Container, Typography, Box, TextField, Button, MenuItem, Select, InputLabel, FormControl,
  CircularProgress, Snackbar, Card, CardContent, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, IconButton, Dialog, DialogTitle, DialogContent, DialogActions,
  TableSortLabel, Chip
} from '@mui/material';
import { 
  FilterList as FilterListIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  UnfoldMore as UnfoldMoreIcon
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import axios from 'axios';

const FeeStructure = () => {
  const { state } = useLocation();
  const { schoolId } = state || {};

  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [className, setClassName] = useState('');
  const [term, setTerm] = useState('Term 1');
  const [amount, setAmount] = useState('');
  const [feeStructures, setFeeStructures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [editingId, setEditingId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'className', direction: 'asc' });
  const [filterYear, setFilterYear] = useState('');
  const [filterTerm, setFilterTerm] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState({ open: false, feeId: null });

  const classes = [
    'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6',
    'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12'
  ];

  const terms = ['Term 1', 'Term 2', 'Term 3'];

  useEffect(() => {
    if (schoolId) fetchFeeStructures();
  }, [schoolId, sortConfig, filterYear, filterTerm]);

  const fetchFeeStructures = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://kidsm.vercel.app/api/schools/${schoolId}/filtered-fee-structures`,
        {
          params: {
            year: filterYear,
            term: filterTerm,
            sortBy: sortConfig.key,
            sortOrder: sortConfig.direction
          }
        }
      );
      setFeeStructures(response.data);
    } catch (error) {
      console.error('Error fetching fee structures:', error);
      setSnackbar({ open: true, message: 'Failed to fetch fee structures', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!year || !className || !term || !amount) {
      setSnackbar({ open: true, message: 'Please fill all fields', severity: 'error' });
      return;
    }

    if (isNaN(amount)) {
      setSnackbar({ open: true, message: 'Amount must be a number', severity: 'error' });
      return;
    }

    try {
      const payload = {
        schoolId,
        year,
        className,
        term,
        amount: parseFloat(amount),
        id: editingId || undefined
      };

      const response = await axios.post(
        'https://kidsm.vercel.app/api/schools/update-fee-structure',
        payload
      );

      setSnackbar({ open: true, message: response.data.message, severity: 'success' });
      fetchFeeStructures();
      resetForm();
    } catch (error) {
      console.error('Error updating fee structure:', error);
      setSnackbar({ open: true, message: 'Failed to update fee structure', severity: 'error' });
    }
  };

  const handleEdit = (fee) => {
    setYear(fee.year);
    setClassName(fee.className);
    setTerm(fee.term);
    setAmount(fee.amount.toString());
    setEditingId(fee._id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (feeId) => {
    setConfirmDelete({ open: true, feeId });
  };

  const confirmDeleteAction = async () => {
    try {
      await axios.delete(`https://kidsm.vercel.app/api/schools/fee-structure/${confirmDelete.feeId}`);
      setSnackbar({ open: true, message: 'Fee structure deleted successfully', severity: 'success' });
      fetchFeeStructures();
    } catch (error) {
      console.error('Error deleting fee structure:', error);
      setSnackbar({ open: true, message: 'Failed to delete fee structure', severity: 'error' });
    } finally {
      setConfirmDelete({ open: false, feeId: null });
    }
  };

  const resetForm = () => {
    setYear(new Date().getFullYear().toString());
    setClassName('');
    setTerm('Term 1');
    setAmount('');
    setEditingId(null);
  };

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const getSortedData = () => {
    let filteredData = [...feeStructures];
    
    if (searchQuery) {
      filteredData = filteredData.filter(fee => 
        fee.className.toLowerCase().includes(searchQuery.toLowerCase()) ||
        fee.year.toString().includes(searchQuery) ||
        fee.term.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    
    return filteredData;
  };

  const groupByClass = () => {
    const grouped = {};
    const data = getSortedData();
    
    data.forEach(fee => {
      if (!grouped[fee.className]) {
        grouped[fee.className] = [];
      }
      grouped[fee.className].push(fee);
    });
    
    return grouped;
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return <UnfoldMoreIcon fontSize="small" />;
    return sortConfig.direction === 'asc' ? 
      <ArrowUpwardIcon fontSize="small" /> : 
      <ArrowDownwardIcon fontSize="small" />;
  };

  if (!schoolId) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, minHeight: '100vh' }}>
        <Typography variant="h6" sx={{ textAlign: 'center', color: 'error.main' }}>
          Error: No school ID provided
        </Typography>
      </Container>
    );
  }

  const groupedData = groupByClass();

  return (
    <Container maxWidth="lg" sx={{ py: 4, minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 4, textAlign: 'center' }}>
          {editingId ? 'Edit Fee Structure' : 'Add New Fee Structure'}
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
          <TextField
            fullWidth
            label="Year"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            placeholder="e.g. 2023"
            type="number"
            variant="outlined"
          />

          <FormControl fullWidth>
            <InputLabel id="class-label">Class</InputLabel>
            <Select
              labelId="class-label"
              value={className}
              label="Class"
              onChange={(e) => setClassName(e.target.value)}
            >
              <MenuItem value="">Select Class</MenuItem>
              {classes.map((cls) => (
                <MenuItem key={cls} value={cls}>{cls}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
          <FormControl fullWidth>
            <InputLabel id="term-label">Term</InputLabel>
            <Select
              labelId="term-label"
              value={term}
              label="Term"
              onChange={(e) => setTerm(e.target.value)}
            >
              {terms.map((t) => (
                <MenuItem key={t} value={t}>{t}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Amount (KES)"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount"
            type="number"
            variant="outlined"
          />
        </Box>

        <Box sx={{ display: 'flex', gap: 2, mb: 4 }}>
          <Button
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            sx={{
              bgcolor: '#6200ee',
              py: 1.5,
              '&:hover': { bgcolor: '#3700b3' },
            }}
          >
            {editingId ? 'Update' : 'Submit'}
          </Button>
          
          {editingId && (
            <Button
              fullWidth
              variant="outlined"
              color="error"
              onClick={resetForm}
              sx={{ py: 1.5 }}
            >
              Cancel
            </Button>
          )}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <TextField
            fullWidth
            label="Search by class, year or term"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            variant="outlined"
          />
          <IconButton 
            onClick={() => setShowFilters(true)}
            sx={{ 
              bgcolor: '#6200ee', 
              color: 'white',
              '&:hover': { bgcolor: '#3700b3' }
            }}
          >
            <FilterListIcon />
          </IconButton>
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
          Current Fee Structures
        </Typography>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
            <CircularProgress color="primary" />
          </Box>
        ) : feeStructures.length === 0 ? (
          <Typography sx={{ textAlign: 'center', color: 'text.secondary' }}>
            No fee structures found
          </Typography>
        ) : (
          <TableContainer component={Paper} sx={{ mb: 4 }}>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: '#6200ee' }}>
                  <TableCell>
                    <TableSortLabel
                      active={sortConfig.key === 'className'}
                      direction={sortConfig.direction}
                      onClick={() => requestSort('className')}
                      sx={{ color: 'white !important' }}
                      IconComponent={() => getSortIcon('className')}
                    >
                      <Typography sx={{ color: 'white', fontWeight: 'bold' }}>Class</Typography>
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={sortConfig.key === 'year'}
                      direction={sortConfig.direction}
                      onClick={() => requestSort('year')}
                      sx={{ color: 'white !important' }}
                      IconComponent={() => getSortIcon('year')}
                    >
                      <Typography sx={{ color: 'white', fontWeight: 'bold' }}>Year</Typography>
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={sortConfig.key === 'term'}
                      direction={sortConfig.direction}
                      onClick={() => requestSort('term')}
                      sx={{ color: 'white !important' }}
                      IconComponent={() => getSortIcon('term')}
                    >
                      <Typography sx={{ color: 'white', fontWeight: 'bold' }}>Term</Typography>
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={sortConfig.key === 'amount'}
                      direction={sortConfig.direction}
                      onClick={() => requestSort('amount')}
                      sx={{ color: 'white !important' }}
                      IconComponent={() => getSortIcon('amount')}
                    >
                      <Typography sx={{ color: 'white', fontWeight: 'bold' }}>Amount</Typography>
                    </TableSortLabel>
                  </TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.entries(groupedData).map(([className, fees]) => (
                  <React.Fragment key={className}>
                    <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                      <TableCell colSpan={5}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                          {className}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    {fees.map((fee) => (
                      <TableRow key={fee._id} hover>
                        <TableCell>{fee.className}</TableCell>
                        <TableCell>{fee.year}</TableCell>
                        <TableCell>{fee.term}</TableCell>
                        <TableCell>KES {fee.amount.toLocaleString()}</TableCell>
                        <TableCell>
                          <IconButton onClick={() => handleEdit(fee)} color="primary">
                            <EditIcon />
                          </IconButton>
                          <IconButton onClick={() => handleDelete(fee._id)} color="error">
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </motion.div>

      {/* Filter Dialog */}
      <Dialog open={showFilters} onClose={() => setShowFilters(false)}>
        <DialogTitle>Filter Options</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, my: 2 }}>
            <TextField
              label="Filter by Year"
              value={filterYear}
              onChange={(e) => setFilterYear(e.target.value)}
              placeholder="e.g. 2023"
              type="number"
              fullWidth
            />
            <FormControl fullWidth>
              <InputLabel id="filter-term-label">Filter by Term</InputLabel>
              <Select
                labelId="filter-term-label"
                value={filterTerm}
                label="Filter by Term"
                onChange={(e) => setFilterTerm(e.target.value)}
              >
                <MenuItem value="">All Terms</MenuItem>
                {terms.map((t) => (
                  <MenuItem key={t} value={t}>{t}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowFilters(false)}>Cancel</Button>
          <Button 
            onClick={() => {
              fetchFeeStructures();
              setShowFilters(false);
            }}
            variant="contained"
            color="primary"
          >
            Apply Filters
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={confirmDelete.open} onClose={() => setConfirmDelete({ open: false, feeId: null })}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this fee structure?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDelete({ open: false, feeId: null })}>Cancel</Button>
          <Button 
            onClick={confirmDeleteAction}
            variant="contained"
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        sx={{ 
          '& .MuiSnackbarContent-root': { 
            bgcolor: snackbar.severity === 'success' ? '#4CAF50' : '#f44336' 
          } 
        }}
      />
    </Container>
  );
};

export default FeeStructure;